/* eslint-disable max-len */
import { quotationsTypes } from '../types/quotations.types';

const initState = {
  collection: [],
  count: 0,
  limit: 10,
  allQuotations: [],
  ces: [],
  dataDashboard: {},
  gettingDataDashboard: false,
  summary: {
    total: 0,
  },
  quotationsInfo: {
    haveProperty: false,
    haveVehicle: false,
    status: '',
    _id: '',
    client: {
      _id: '',
      names: '',
      paternalSurname: '',
      maternalSurname: '',
      rut: null,
    },
    executive: {
      _id: '',
      firstName: '',
      lastName: '',
      avatar: '',
    },
    companyName: '',
    companyRUT: '',
    typeContract: '',
    dateEntry: '',
    rent: null,
    workPhone: '',
    officePhone: '',
    origin: '',
    loading: false,
    quotationExcel: '',
    loadingReasing: false,
  },
  exportQuotations: {
    data: null,
    loading: false,
  },
  exportedData: {
    data: null,
    loading: false
  },
};

export default (state = initState, action) => {
  switch (action.type) {
    case quotationsTypes.GET_EXPORT_QUOTATIONS_REQUEST:
      return { ...state, exportQuotations: { ...state.exportQuotations, loading: true, } };
    case quotationsTypes.GET_EXPORT_QUOTATIONS_SUCCESS:
      return { ...state, exportQuotations: { ...state.exportQuotations, loading: false, exportQuotations: action.payload.body } };
    case quotationsTypes.GET_EXPORT_QUOTATIONS_FAILED:
      return { ...state, exportQuotations: { ...state.exportQuotations, loading: false, error: action.payload.error } };
    case quotationsTypes.GET_EXPORT_DATA_REQUEST:
      return { ...state, exportedData: { ...state.exportedData, loading: true } };
    case quotationsTypes.GET_EXPORT_DATA_SUCCESS:
      return {
        ...state,
        exportedData: {
          ...state.exportedData,
          loading: false,
          data: action.payload.body
        }
      };
    case quotationsTypes.GET_EXPORT_DATA_FAILED:
      return {
        ...state,
        exportedData: {
          ...state.exportedData,
          loading: false,
          error: action.payload.error
        }
      };
    case quotationsTypes.GET_SUMMARY_QUOTATIONS:
      return { ...state, loadingQuoationsSummary: true };
    case quotationsTypes.GET_SUMMARY_QUOTATIONS_SUCCESS:
      return {
        ...state,
        loadingQuoationsSummary: false,
        summary: action.payload.summary,
      };
    case quotationsTypes.GET_SUMMARY_QUOTATIONS_FAILED:
      return { ...state, loadingQuoationsSummary: false, error: action.payload.error };
    case quotationsTypes.GET_ALL_QUOTATIONS:
      return { ...state, loadingQuoations: true };
    case quotationsTypes.GET_ALL_QUOTATIONS_SUCCESS:
      return {
        ...state,
        loadingQuoations: false,
        allQuotations: action.payload.allQuotations,
        countQuotations: action.payload.countQuotations,
        limitQuotations: action.payload.limitQuotations,
      };
    case quotationsTypes.GET_ALL_QUOTATIONS_FAILED:
      return { ...state, loadingQuoations: false, error: action.payload.error };
    //obtener concesionarios
    case quotationsTypes.GET_CONCESSIONAIRES:
      return { ...state, loading: true };
    case quotationsTypes.GET_CONCESSIONAIRES_SUCCESS:
      return {
        ...state,
        loading: false,
        ces: action.payload.ces,
      };
    case quotationsTypes.GET_CONCESSIONAIRES_FAILED:
      return { ...state, ces: [], loading: false, error: action.payload.error };
    //fin obtener concesionarios
    case quotationsTypes.GET_ALL_QUOTATIONS_DASHBOARD:
      return { ...state, gettingDataDashboard: true };
    case quotationsTypes.GET_ALL_QUOTATIONS_DASHBOARD_SUCCESS:
      return { ...state, gettingDataDashboard: false, dataDashboard: action.payload };
    case quotationsTypes.GET_ALL_QUOTATIONS_DASHBOARD_FAILED:
      return { ...state, gettingDataDashboard: false, error: action.payload.error };
    //descargar excel
    case quotationsTypes.GET_EXCEL_QUOTATION:
      return { ...state, gettingExcel: true };
    case quotationsTypes.GET_EXCEL_QUOTATION_SUCCESS:
      return { ...state, gettingExcel: false, quotationExcel: action.payload.body };
    case quotationsTypes.GET_EXCEL_QUOTATION_FAILED:
      return { ...state, quotationExcel: '', gettingExcel: false, error: action.payload.error };
    //fin descargar excel
    case quotationsTypes.CREATE_QUOTATIONS:
      return { ...state, loadingCreateQ: true };
    case quotationsTypes.CREATE_QUOTATIONS_SUCCESS:
      return {
        ...state,
        loadingCreateQ: false,
        quotationCreated: action.payload.quotation,
      };
    case quotationsTypes.CREATE_QUOTATIONS_FAILED:
      return { ...state, loadingCreateQ: false, error: action.error };
    case quotationsTypes.GET_QUOTATIONS_ID:
      return { ...state, loadingInfoQuotations: true };
    case quotationsTypes.GET_QUOTATIONS_ID_SUCCESS:
      return {
        ...state,
        loadingInfoQuotations: false,
        quotationInfo: action.payload.quotationInfo,
      };
    case quotationsTypes.GET_QUOTATIONS_ID_FAILED:
      return { ...state, loadingInfoQuotations: false, error: action.payload.error };
    case quotationsTypes.UPDATE_QUOTATIONS:
      return { ...state, disableCloseQuotations: true };
    case quotationsTypes.UPDATE_QUOTATIONS_SUCCESS:
      return {
        ...state,
        disableCloseQuotations: false,
      };
    case quotationsTypes.UPDATE_QUOTATIONS_FAILED:
      return { ...state, disableCloseQuotations: false, error: action.error };
    case quotationsTypes.UPDATE_QUOTATION_MANY:
      return { ...state, loadingReasing: true };
    case quotationsTypes.UPDATE_QUOTATION_MANY_SUCCESS:
      return {
        ...state,
        loadingReasing: false,
      };
    case quotationsTypes.UPDATE_QUOTATION_MANY_FAILED:
      return { ...state, loadingReasing: false, error: action.error };
    case quotationsTypes.DELETE_QUOTATIONS:
      return { ...state };
    case quotationsTypes.DELETE_QUOTATIONS_SUCCESS:
      return { ...state };
    case quotationsTypes.DELETE_QUOTATIONS_FAILED:
      return { ...state };
    default:
      return state;
  }
};